import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';

export const adalConfig = {
    tenant: '9222a86a-75cf-4a84-b36d-6b7706aee958',
    //clientId: "1305964c-d3c4-4051-b6ab-f2898b71cb6f", //PROD
    clientId: "b240d856-69b1-49f9-a5d9-bf1835425091", //UAT
    //clientId: "cdaf97a0-d4b9-46af-b796-90b80fe8d79e",//LOCAL
    //redirectUri: 'https://lpb.awex.com.au/signinlpb', //PROD
    redirectUri: 'https://lpbuat.awex.com.au/signinlpb', //UAT
    ///redirectUri: 'https://localhost:44388/signinlpb',//LOCAL
    endpoints: {
        //api: "1305964c-d3c4-4051-b6ab-f2898b71cb6f", //PROD
        api: 'b240d856-69b1-49f9-a5d9-bf1835425091', //UAT
        //api: 'cdaf97a0-d4b9-46af-b796-90b80fe8d79e',//LOCAL
    },     
    cacheLocation: 'sessionStorage',
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);

export const getToken = () => authContext.getCachedToken(adalConfig.clientId);